import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';
import { ContentProvider, useContent } from './lib/ContentContext';
import { trackPageView } from './lib/analytics';
import { Header } from './components/site/Header';
import { Footer } from './components/site/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Textile from './pages/Textile';
import TextileCategory from './pages/TextileCategory';
import IndustryProducts from './pages/IndustryProducts';
import RDSustainability from './pages/RDSustainability';
import News from './pages/News';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import LegalPage from './pages/LegalPage';
import AdminApp from './admin/AdminApp';
import { Loader2 } from 'lucide-react';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Skip tracking admin/CMS usage - only measure public site visitors.
    if (pathname.startsWith('/admin')) return;
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);
  return null;
};

const PublicLayout = ({ children }) => {
  const { loading } = useContent();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="h-10 w-10 animate-spin text-[#26247B]" />
      </div>
    );
  }
  return (
    <div className="site-body min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route
            path="*"
            element={
              <PublicLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about-us" element={<About />} />
                  <Route path="/textile-chemicals" element={<Textile />} />
                  <Route path="/textile-chemicals/:slug" element={<TextileCategory />} />
                  <Route path="/leather-chemicals" element={<IndustryProducts contentKey="leather_page" />} />
                  <Route path="/paper-chemicals" element={<IndustryProducts contentKey="paper_page" />} />
                  <Route path="/paints-coatings-chemicals" element={<IndustryProducts contentKey="paints_page" />} />
                  <Route path="/rd-sustainability" element={<RDSustainability />} />
                  <Route path="/news-insights" element={<News />} />
                  <Route path="/news-insights/:slug" element={<BlogPost />} />
                  <Route path="/contact-us" element={<Contact />} />
                  <Route path="/privacy-policy" element={<LegalPage contentKey="privacy_page" />} />
                  <Route path="/terms-of-use" element={<LegalPage contentKey="terms_page" />} />
                </Routes>
              </PublicLayout>
            }
          />
        </Routes>
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
